export const Tipos = (app) => {
	return {
        Tipos: {
            Perfil: {
                Dev: 11,
                Pro: 12
            },
        
            CenarioLog: {
                Painel: 0,
                Tabela: 1,
                TabelaDinamica: 2,
                ExportacaoDados: 3,
                Grafico: 4,
                Planilha: 5,
                Medidor: 6,
                VarMedidor: 7,
                Mapa: 8,
                Formulario: 9,
                SQL: 10,
                Iniciativa: 11,
                Seletor: 12
            },

            CenarioDependencias: {
                Cubo: 0,
                Grid: 1,
                Medidor: 2,
                Grafico: 3,
                Planilha: 4,
                PainelWeb: 5,
                SQL: 6,
                Seletor: 7,
                VarMedidor: 8,
                EstiloMedidor: 9,
                Mapa: 10,
                VarUsuario: 11,
                PainelDesktop: 12
            },

            TipoSeletor: {
                Nenhum: -1,
                ConsultaSQL: 0,
                Texto: 1,
                NumeroInteiro: 2,
                NumeroDecimal: 3,
                Data: 4,
                CaixaMarcacao: 5,
                CaixaCombinacao: 6,
                RequisicaoAPI: 7
            },

            TipoComponente: {
                Texto: 0,
                CaixaMarcacao: 1,
                CaixaCombinacao: 2, 
                ConsultaSQL: 3,
                Seletor: 4,
                Data: 5,
                DataHora: 6, 
                Hora: 7,
                CaixaTexto: 8,
                BotaoOpcao: 9,
                ValorPadrao: 10
            },

            TipoFiltroInicial: {
                Nenhum: 0,
                ContemIn: 1,
                ContemLike: 2,
                EstaEntre: 3,
                Diferente: 4,
                Igual: 5,
                Maior: 6,
                MaiorIgual: 7,
                Menor: 8,
                MenorIgual: 9,
                IniciaCom: 10,
                NaoContemIn: 11,
                NaoContemLike: 12,
                NaoEstaEntre: 13,
                NaoIniciaCom: 14,
                NaoTerminaCom: 15,
                TerminaCom: 16
            },

            TipoFiltroSelecao: {
                SelecaoUsuario: 0,
                TodosValores: 1,
                PrimeiroValor: 2,
                PrimeiroUltimoValor: 3            
            },

            ModoEdicaoCampoFormulario: {
                Linha: 0,
                Celula: 1,
                Lote: 2, 
                Formulario: 3,
                Popup: 4
            },

            TipoValorPadraoFormulario: {
                Nenhum: 0,
                ValorPadrao: 1,
                ConsultaSQL: 2
            },

            OrigemExecucao: {
                Padrao: 'Menu',
                LinkAgendamento: 'Link Agendamento',
                Snapshot: 'Snapshot'
            },

            MenuLayout: {
                Automatico: 1,
                SomenteIcone: 2, 
                SomenteTexto: 3, 
                IconeETexto: 4
            },

            MenuIcone: {
                Icone: 'icon',
                Imagem: 'image'
            },

            getTemplatesMenu() {
                return [
                    { id: 'Vertical_1', nome: app.config.globalProperties.$vistra.globalize('menu-template-vertical-1') },
                    { id: 'Horizontal_1', nome: app.config.globalProperties.$vistra.globalize('menu-template-horizontal-1')},
                ]
            },

            Acao: {
                AbrirPainel: 1,
                FocarAba: 2,
                FocarObjeto: 3,
                Filtrar: 4,
                AbrirFormulario: 5
            },

            TipoCampo: {
                Number: 'number',
                Date: 'date',
                DateTime: 'datetime',
                Boolean: 'boolean',
                String: 'string'
            },

            //---- Parâmetros globais de painéis -----
            TipoParametroGlobal: { 
                Fixo: 0, 
                Variavel: 1 
            },

            SubTipoParametroGlobal: { 
                Data: 0, 
                Seletor: 1, 
                Geral: 2, 
                VariavelUsuario: 3,
                FonteDeDados: 4
            },

            getTipoComponenteSeletor(subTipo, tipoApresentacao) {
                switch (subTipo) {
                    //parâmetro painel
                    case this.SubTipoParametroGlobal.Data:
                        return this.TipoSeletor.Data;
                    case this.SubTipoParametroGlobal.Geral:
                        switch (tipoApresentacao) {
                            case 0:
                                return this.TipoSeletor.Texto;
                            case 1:
                                return this.TipoSeletor.CaixaMarcacao;
                            case 2:
                                return this.TipoSeletor.CaixaCombinacao;
                            case 3:
                                return this.TipoSeletor.NumeroInteiro;
                            case 4:
                                return this.TipoSeletor.NumeroDecimal;
                        }
                    //seletor
                    default:
                        switch (tipoApresentacao) {
                            case 0:
                                return this.TipoSeletor.ConsultaSQL;
                            case 1:
                                return this.TipoSeletor.Texto;
                            case 2:
                                return this.TipoSeletor.NumeroInteiro;
                            case 3:
                                return this.TipoSeletor.NumeroDecimal;
                            case 4:
                                return this.TipoSeletor.Data;
                            case 5:
                                return this.TipoSeletor.CaixaMarcacao;
                            case 6:
                                return this.TipoSeletor.CaixaCombinacao;
                            case 7:
                                return this.TipoSeletor.RequisicaoAPI;
                        }
                }
                return this.TipoSeletor.Texto;
            },

            getTipoParametroGlobalVariavel(subTipo, tipoApresentacao) {           
                switch (subTipo) {
                    case this.SubTipoParametroGlobal.Data:    
                        return this.TipoSeletor.Data;
                    case this.SubTipoParametroGlobal.Seletor:    
                        switch (tipoApresentacao) {
                            case 1:
                                return this.TipoSeletor.CaixaMarcacao;
                            case 2:
                                return this.TipoSeletor.CaixaCombinacao;
                            case 3:
                                return this.TipoSeletor.NumeroInteiro;
                            case 4:
                                return this.TipoSeletor.NumeroDecimal;
                        }
                }
                return this.TipoSeletor.Texto;
            },

            VariavelGlobalVariavel: {
                Data: 0,
                CaixaMarcacao: 1,
                CaixaCombinacao: 2,
                NumeroInteiro: 3,
                NumeroDecimal: 4
            },
            
            FuncaoGeral: { 
                Geral: 0, 
                DiaCorrente: 1, 
                MesCorrente: 2, 
                AnoCorrente: 3, 
                DiaCorrenteNDias: 4, 
                MesCorrenteNMeses: 5, 
                AnoCorrenteNAnos: 6, 
                UltimoDiaDoMesCorrente: 7 
            },

            FuncaoData: {
                SemReferencia: 0,
                DataCorrente: 1,
                PrimeiroDiaMesCorrente: 2,
                UltimoDiaMesCorrente: 3,
                DataCorrenteNDias: 4,
                DataCorrenteNMeses: 5,
                Personalizada: 6
            },
            //--- Agendamento ----
            Agendamento: {
                Periodicidade: {
                    UmaVez: 0, 
                    Diariamente: 1, 
                    Semanalmente: 2, 
                    Mensalmente: 3, 
                    IntervaloDeDias: 4,
                    Nunca: 5
                },
                getPeriodicidade() {
                    return [
                        { id: this.Periodicidade.UmaVez, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-periodicidade-umavez") },
                        { id: this.Periodicidade.Diariamente, nome: app.config.globalProperties.$vistra.globalize("dxScheduler-recurrenceDaily") },
                        { id: this.Periodicidade.Semanalmente, nome: app.config.globalProperties.$vistra.globalize("dxScheduler-recurrenceWeekly") },
                        { id: this.Periodicidade.Mensalmente, nome: app.config.globalProperties.$vistra.globalize("dxScheduler-recurrenceMonthly") },
                        { id: this.Periodicidade.IntervaloDeDias, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-periodicidade-intervalodedias") }
                    ]
                },

                Saida: {
                    Link: 0,
                    SnapShot: 1
                },
                getTipoSaida() {
                    return [
                        { id: this.Saida.Link, nome: app.config.globalProperties.$vistra.globalize('saida-agendamento-link') },
                        { id: this.Saida.SnapShot, nome: app.config.globalProperties.$vistra.globalize('saida-agendamento-snapshot') }
                    ]      
                },

                Status: { 
                    Executando: -1,
                    Aguardando: 0, 
                    Atrasado: 1, 
                    Concluido: 2, 
                    Erro: 3,
                    Inativo: 4
                },
                getStatus() {
                    return [
                        { id: this.Status.Executando, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-executando"), icon: "fas fa-spinner fa-pulse", cor: "blue"},
                        { id: this.Status.Aguardando, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-aguardando"), icon: "far fa-ellipsis-h", cor: "orange" },
                        { id: this.Status.Atrasado, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-atrasado"), icon: "fal fa-alarm-exclamation", cor: "yellow" },
                        { id: this.Status.Concluido, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-concluido"), icon: "fal fa-check", cor: "green" },
                        { id: this.Status.Erro, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-erro"), icon: "fal fa-exclamation-triangle", cor: "red" },
                        { id: this.Status.Inativo, nome: app.config.globalProperties.$vistra.globalize("form-agendamento-status-inativo"), icon: "fal fa-power-off", cor: "gray" }
                    ]
                },

                MensagemLogAgendamento: { 
                    Informacao: 0, 
                    Atencao: 1, 
                    Erro: 2
                },

                Parametro: { 
                    ParametroGlobal: 0, 
                    ComponenteSeletor: 1 
                },

                Funcao: {
                    Geral: 0, 
                    Data: 1 
                },

                PersonalizadaDia: { 
                    SemReferencia: 0, 
                    UltimoDiaDoMes: 1, 
                    DiaCorrenteNDias: 2 
                },

                PersonalizadaMes: { 
                    SemReferencia: 0, 
                    MesCorrenteNMeses: 1 
                },

                PersonalizadaAno: { 
                    SemReferencia: 0, 
                    AnoCorrenteNAnos: 1 
                }
            },

            //Alerta
            Alerta: {
                FrequenciaDiaria: {
                    UmaVez: 0,
                    Intervalo: 1
                },
                OrigemIndicador: {
                    ConsultaSQL: 0,
                    VariavelDeUsuario: 1
                },
                getOrigensIndicador() {
                    return [
                        { id: this.OrigemIndicador.ConsultaSQL, nome: app.config.globalProperties.$vistra.globalize('form-alerta-indicador-origem-sql') },
                        { id: this.OrigemIndicador.VariavelDeUsuario, nome: app.config.globalProperties.$vistra.globalize('form-alerta-indicador-origem-variavel-usuario') }
                    ]
                },
                QuandoNotificar: { 
                    AoSeTornarVerdadeira: 0, 
                    TodaVezQueVerdadeira: 1
                },
                getQuandoNotificar() {
                    return [
                        { id: this.QuandoNotificar.AoSeTornarVerdadeira, nome: app.config.globalProperties.$vistra.globalize('form-alerta-quando-notificar-tornar-verdadeira') },
                        { id: this.QuandoNotificar.TodaVezQueVerdadeira, nome: app.config.globalProperties.$vistra.globalize('form-alerta-quando-notificar-todavez-verdadeira') }
                    ]
                },
                LimiteNotificacoes: { 
                    UmaVezPorHora: 0, 
                    UmaVezPorDia: 1
                },
                getLimiteNotificacoes() {
                    return [
                        { id: this.LimiteNotificacoes.UmaVezPorHora, nome: app.config.globalProperties.$vistra.globalize('form-alerta-limite-notificacoes-hora') },
                        { id: this.LimiteNotificacoes.UmaVezPorDia, nome: app.config.globalProperties.$vistra.globalize('form-alerta-limite-notificacoes-dia') }
                    ]
                }
            },

            getTiposCampo() {
                return [
                    { value: this.TipoCampo.String,  text: app.config.globalProperties.$vistra.globalize("form-objeto-tabela-config-campo-tipo-dado-texto") },
                    { value: this.TipoCampo.Number,  text: app.config.globalProperties.$vistra.globalize("form-objeto-tabela-config-campo-tipo-dado-numero") },
                    { value: this.TipoCampo.Date,    text: app.config.globalProperties.$vistra.globalize("form-objeto-tabela-config-campo-tipo-dado-data") },
                    { value: this.TipoCampo.DateTime,text: app.config.globalProperties.$vistra.globalize("form-objeto-tabela-config-campo-tipo-dado-datahora") },
                    { value: this.TipoCampo.Boolean, text: app.config.globalProperties.$vistra.globalize("form-objeto-tabela-config-campo-tipo-dado-logico") }                
                ]
            },

            getTipoCampoByTipoJS(tipoJS) {
                switch(tipoJS) {
                    case "number":
                        return "DOUBLE"
                    case "datetime":
                        return "DATETIME"
                    case "boolean":
                        return "BOOLEAN"
                    case "string":
                    default:
                        return "VARYING"
                }
            },

            getTipoCampo(tipo) {
                switch (tipo) {
                    case "BLOB":
                        return undefined;
                    case "DATE":
                    case "TIME":
                    case "DATETIME":
                        return "datetime";
                    case "DOUBLE":
                    case "INTEGER":
                        return "numeric";
                    case "BOOLEAN":
                        return "boolean"
                    case "VARYING":
                    default:
                        return "string";
                }
            },

            //no lugar de retornar string, retorna o proprio tipo... usado por exemplo qdo temos variaveis de painel e card juntas
            getTipoGeral(tipo) {
                switch (tipo) {
                    case "BLOB":
                        return undefined;
                    case "DATE":
                    case "TIME":
                    case "DATETIME":
                        return "date";
                    case "DOUBLE":
                    case "INTEGER":
                        return "number";
                    case "BOOLEAN":
                        return "boolean"
                    case "VARYING":
                        return "string";
                    default:
                        return tipo;
                }
            },
            getTipoFormatacao(tipo) {
                switch (tipo.toUpperCase())
                {
                    case "DATE":
                        return  {
                            
                            type: "shortDate"
                        };
                    case "DATETIME": 
                        return  {
                        
                            type: "shortDateShortTime"
                        };
                    case "TIME":
                        return  {
                            
                            type: "shortTime"
                        }
                    case "DOUBLE":
                        return  {
                            
                            type: "fixedPoint",
                        }
                    case "INTEGER":
                    case "INT":
                        return  {
                            
                            type: "fixedPoint",
                        }
                }
            },
            listaIdentificadores: [
                { index: 0, mask: "00.000.000/0000-00", nome: "CNPJ" },
                { index: 1, mask: "000.000.000-00", nome: "CPF" }
            ],

            getTiposFormatacao() {
                return [
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'currency', text: app.config.globalProperties.$vistra.globalize('format.currency') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'currency thousands', text: app.config.globalProperties.$vistra.globalize('format.currency_thousands') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'currency millions', text: app.config.globalProperties.$vistra.globalize('format.currency_millions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'currency billions', text: app.config.globalProperties.$vistra.globalize('format.currency_billions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'currency trillions', text: app.config.globalProperties.$vistra.globalize('format.currency_trillions') },
                    //esse tipo é meio bugado
                // { grupo: ['DOUBLE', 'INTEGER'], value: 'decimal', text: app.config.globalProperties.$vistra.globalize('format.decimal') },
                // { grupo: ['DOUBLE', 'INTEGER'], value: 'decimal thousands', text: app.config.globalProperties.$vistra.globalize('format.decimal_thousands') },
                // { grupo: ['DOUBLE', 'INTEGER'], value: 'decimal millions', text: app.config.globalProperties.$vistra.globalize('format.decimal_millions') },
                // { grupo: ['DOUBLE', 'INTEGER'], value: 'decimal billions', text: app.config.globalProperties.$vistra.globalize('format.decimal_billions') },
                // { grupo: ['DOUBLE', 'INTEGER'], value: 'decimal trillions', text: app.config.globalProperties.$vistra.globalize('format.decimal_trillions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'fixedPoint', text: app.config.globalProperties.$vistra.globalize('format.fixedPoint') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'fixedPoint thousands', text: app.config.globalProperties.$vistra.globalize('format.fixedPoint_thousands') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'fixedPoint millions', text: app.config.globalProperties.$vistra.globalize('format.fixedPoint_millions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'fixedPoint billions', text: app.config.globalProperties.$vistra.globalize('format.fixedPoint_billions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'fixedPoint trillions', text: app.config.globalProperties.$vistra.globalize('format.fixedPoint_trillions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'exponential', text: app.config.globalProperties.$vistra.globalize('format.exponential') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'largeNumber', text: app.config.globalProperties.$vistra.globalize('format.largeNumber') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'percent', text: app.config.globalProperties.$vistra.globalize('format.percent') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'thousands', text: app.config.globalProperties.$vistra.globalize('format.thousands') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'millions', text: app.config.globalProperties.$vistra.globalize('format.millions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'billions', text: app.config.globalProperties.$vistra.globalize('format.billions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'trillions', text: app.config.globalProperties.$vistra.globalize('format.trillions') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'n_minute', text: app.config.globalProperties.$vistra.globalize('format.minute') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'n_hour', text: app.config.globalProperties.$vistra.globalize('format.hour') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'n_shortTime', text: app.config.globalProperties.$vistra.globalize('format.shortTime') },
                { grupo: ['DOUBLE', 'INTEGER', 'NUMBER'], value: 'n_longTime', text: app.config.globalProperties.$vistra.globalize('format.longTime') },
                { grupo: ['DATETIME'], value: 'longDateLongTime', text: app.config.globalProperties.$vistra.globalize('format.longDateLongTime') },
                { grupo: ['DATETIME'], value: 'shortDateShortTime', text: app.config.globalProperties.$vistra.globalize('format.shortDateShortTime') },
                { grupo: ['DATETIME', 'DATE'], value: 'day', text: app.config.globalProperties.$vistra.globalize('format.day') },
                { grupo: ['DATETIME', 'DATE'], value: 'dayOfWeek', text: app.config.globalProperties.$vistra.globalize('format.dayOfWeek') },
                { grupo: ['DATETIME', 'DATE'], value: 'month', text: app.config.globalProperties.$vistra.globalize('format.month') },
                { grupo: ['DATETIME', 'DATE'], value: 'year', text: app.config.globalProperties.$vistra.globalize('format.year') },
                { grupo: ['DATETIME', 'DATE'], value: 'longDate', text: app.config.globalProperties.$vistra.globalize('format.longDate') },
                { grupo: ['DATETIME', 'DATE'], value: 'shortDate', text: app.config.globalProperties.$vistra.globalize('format.shortDate') },
                { grupo: ['DATETIME', 'DATE'], value: 'monthAndDay', text: app.config.globalProperties.$vistra.globalize('format.monthAndDay') },
                { grupo: ['DATETIME', 'DATE'], value: 'dd/MM', text: app.config.globalProperties.$vistra.globalize('format.monthAndDay-curto') },                
                { grupo: ['DATETIME', 'DATE'], value: 'monthAndYear', text: app.config.globalProperties.$vistra.globalize('format.monthAndYear') },
                { grupo: ['DATETIME', 'DATE'], value: 'MM/yyyy', text: app.config.globalProperties.$vistra.globalize('format.monthAndYear-curto') },
                { grupo: ['DATETIME', 'DATE'], value: 'quarter', text: app.config.globalProperties.$vistra.globalize('format.quarter') },
                { grupo: ['DATETIME', 'DATE'], value: 'quarterAndYear', text: app.config.globalProperties.$vistra.globalize('format.quarterAndYear') },
                { grupo: ['DATETIME', 'TIME'], value: 'millisecond', text: app.config.globalProperties.$vistra.globalize('format.millisecond') },
                { grupo: ['DATETIME', 'TIME'], value: 'second', text: app.config.globalProperties.$vistra.globalize('format.second') },
                { grupo: ['DATETIME', 'TIME'], value: 'minute', text: app.config.globalProperties.$vistra.globalize('format.minute') },
                { grupo: ['DATETIME', 'TIME'], value: 'hour', text: app.config.globalProperties.$vistra.globalize('format.hour') },
                { grupo: ['DATETIME', 'TIME'], value: 'shortTime', text: app.config.globalProperties.$vistra.globalize('format.shortTime') },
                { grupo: ['DATETIME', 'TIME'], value: 'longTime', text: app.config.globalProperties.$vistra.globalize('format.longTime') },
                ]
            },

            //--- Mapas ---
            DirecaoLegenda: {
                AscendenteVertical: 'ASC-V',
                DescendenteVertical: 'DESC-V',
                AscendenteHorizontal: 'ASC-H',
                DescendenteHorizontal: 'DESC-H'
            },
            PosicaoLegenda: {
                AcimaEsquerda: 'TOP-LEFT',
                AcimaDireita: 'TOP-RIGHT',
                AbaixoEsquerda: 'BOTTOM-LEFT',
                AbaixoDireita: 'BOTTOM-RIGHT'
            },
            LegendaOrdenarPor: {
                Agrupamento: 'AGRUPAMENTO',
                Valor: 'VALOR'
            }
        },

        //deixa fora o que precisa de tradução
        getTiposOrigemConexaoExterna() {
            return [
                { id: "ANYWHERE", nome: "AnyWhere" },
                { id: "API", nome: "API" },
                { id: "DB2", nome: "DB2" },
                { id: "BIGQUERY", nome: "BigQuery" },
                { id: "FIREBIRD", nome: "Firebird" },
                { id: "MYSQL3.51", nome: "MySQL 3.51" },
                { id: "MYSQL5.1", nome: "MySQL 5.1" },
                { id: "ORACLE", nome: "Oracle" },
                { id: "POSTGRES", nome: "PostgreSQL" },
                { id: "PROGRESS", nome: "Progress" },
                { id: "SQLSERVER2000", nome: "SQLServer 2000" },
                { id: "SQLSERVER2005", nome: "SQLServer 2005" },
                { id: "SQLSERVER2008", nome: "SQLServer 2008" },
                { id: "SQLSERVER2019", nome: "SQLServer 2019" },
                { id: "GENERIC", nome: this.globalize("generico") }
            ]
        }
    }
}
